/* Sidrena cijena (NN 101/2026) – keeps the PDP anchor line in sync with the selected variant.
   Installed by AIO cjenik ThemePatcher. Theme-agnostic: reads the JSON map emitted by
   snippets/sidrena-cijena.liquid and the product form's [name="id"] input. */
(function () {
  if (window.__sidrenaCijena) { return; }
  window.__sidrenaCijena = true;

  var style = document.createElement('style');
  style.textContent =
    '.sidrena-cijena{display:block;font-size:12px;line-height:1.4;color:#6b6b6b;margin-top:2px;font-weight:400}' +
    '.sidrena-cijena--single{flex:0 0 100%;width:100%}' +
    '.sidrena-cijena--grid{font-size:11px}' +
    '.sidrena-cijena--cart{font-size:11px}' +
    '.sidrena-cijena__iznos{white-space:nowrap}';
  document.head.appendChild(style);

  function maps() {
    var out = {};
    var nodes = document.querySelectorAll('script[data-sidrena-map]');
    for (var i = 0; i < nodes.length; i++) {
      try { out[nodes[i].getAttribute('data-sidrena-map')] = JSON.parse(nodes[i].textContent); } catch (e) { /* ignore */ }
    }
    return out;
  }

  function selectedVariant(el) {
    var node = el;
    while (node && node !== document.body) {
      var input = node.querySelector('form[action*="/cart/add"] [name="id"], [name="id"]');
      if (input && input.value) { return String(input.value); }
      node = node.parentElement;
    }
    try { return new URL(window.location.href).searchParams.get('variant'); } catch (e) { return null; }
  }

  function refresh() {
    var all = maps();
    var targets = document.querySelectorAll('[data-sidrena-single]');
    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      var map = all[el.getAttribute('data-sidrena-single')];
      if (!map) { continue; }
      var entry = map[selectedVariant(el)];
      if (!entry) { el.hidden = true; continue; }
      var html = 'Cijena na ' + entry.d + ': <span class="sidrena-cijena__iznos">' + entry.c + '</span>';
      if (el.innerHTML !== html) { el.innerHTML = html; }
      el.hidden = false;
    }
  }

  function later(ms) { return function () { window.setTimeout(refresh, ms); }; }
  document.addEventListener('change', later(60), true);
  document.addEventListener('click', later(150), true);
  window.addEventListener('popstate', refresh);

  var pending = false;
  var observer = new MutationObserver(function (mutations) {
    if (pending) { return; }
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (t.nodeType !== 1) { t = t.parentElement; }
      if (t && t.closest && t.closest('[data-product-price],[data-pr-price],form[action*="/cart/add"]')) {
        pending = true;
        window.setTimeout(function () { pending = false; refresh(); }, 0);
        return;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value'] });

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', refresh); } else { refresh(); }
})();
